import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { LoginService } from '../services/login.service';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  hide = true;
  buttonMode = '';
  showMessage;
  responseCode;

  constructor(private router: Router, private loginService: LoginService, private globalService: GlobalService,private matDialog: MatDialog) { }
  ngOnInit() {
    if (localStorage.getItem('token')) {
      this.router.navigate(['/dashboard']);
    }
  }
  form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    pass: new FormControl('', [Validators.required]),
  });
  
  submit() {
    this.buttonMode = 'indeterminate';
    if (this.form.valid) {
      console.log("form data=======", this.form.value)
      if(this.form.value.email === 'dtms@gmail.com'){
        this.buttonMode = '';
        this.responseCode = '-1';
        this.showMessage = 'Invalid Credentials'; 
      }else{
        this.loginService.checkCredential(this.form.value).subscribe((response: any) => {
          console.log("response=======", response)
          if (response && response.code === '1') {
            if (localStorage.getItem('token')) {
              this.buttonMode = '';
              alert("Kindly logout from previous session");
            } else {
              this.responseCode = response.code;
              this.globalService.setLoginLocalStorage(response);
              if(response.userid != 283){
                let audio = new Audio();
                audio.src = "assets/sound/Welcome.mp3";
                audio.load();
                audio.play();
              }
              if(response.dashboard === 2){
                if(response.roleid == 1){
                  this.router.navigate(['/energymetermanager']);                 
                } else{
                  this.router.navigate(['/ems']);
                }
              } else if(response.dashboard == 5){
                this.router.navigate(['/feederDashboard']);
              } else if(response.dashboard == 6){
                this.router.navigate(['/jourgeMachineDahboard']);
              } else if(response.dashboard == 7){
                this.router.navigate(['/solarDashboard']);
              }else if(response.dashboard == 8){
                this.router.navigate(['/announceator']);
              }else if(response.dashboard == 9){
                this.router.navigate(['/digiDashboard']);
              } else {
                  this.router.navigate(['/dashboard']);
              }

            }
  
          } else {
            this.buttonMode = '';
            this.responseCode = response.code;
            if(response.userid != 283){
              let audio = new Audio();
              audio.src = "assets/sound/sorryaudio.mp3";
              audio.load();
              audio.play();
            }
            this.showMessage = 'Invalid Credentials';
          }
        }) 
      }

    } else {
      this.buttonMode = '';
    }
  }
  openForgotPasswordComponent(){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '80%';
    dialogConfig.width = '40%';

    let dialogRef = this.matDialog.open(ForgotpasswordComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
    })
  }

}
